exports = module.exports = require("../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".product-list-item {\n  display: inline-block;\n  width: 25%;\n  padding: 16px;\n}\n.product-list-item a {\n  color: #000000;\n}\n@media only screen and (max-width: 768px) {\n  .product-list-item {\n    width: 100%;\n  }\n}\n", ""]);

